import {
  Form,
  Input,
  DatePicker,
  Switch,
  Row,
  Col,
  Button
} from 'ant-design-vue'
import moment from 'moment'
import BSelect from '../Select/select'
import styles from './search.module.less'

const FormItem = Form.Item
// const Option = Select.Option
const RangePicker = DatePicker.RangePicker

const Search = {
  name: 'BSearch',
  components: {
    BSelect
  },
  props: {
    searchList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      form: this.$form.createForm(this)
    }
  },
  methods: {
    getStartTimeAndEndTime (values) {
      const { time } = values
      if (!time || time.length === 0) {
        return {
          ...values
        }
      } else {
        let beginTime = this.$u.formatDateByMilliSeconds(moment(time[0]))
        let endTime = this.$u.formatDateByMilliSeconds(moment(time[1]))
        beginTime = beginTime.split(' ')[0]
        endTime = endTime.split(' ')[0]
        beginTime = new Date(beginTime)
        endTime = new Date(endTime)
        // const endTime = this.$u.formatDateByMilliSeconds(moment(time[1]))
        // const beginTime = time[0]
        // const endTime = time[1]
        return {
          ...values,
          beginTime,
          endTime
        }
      }
    },
    searchHandler () {
      // let values = this.form.getFieldsValue()
      this.form.validateFields((e, values) => {
        console.log(values)
        values = this.getStartTimeAndEndTime(values)
        this.$emit('on-search', values)
      })
    },
    resetHandler () {
      this.form.resetFields()
      this.$emit('on-search', {})
    },
    renderFormItem (fields) {
      const { getFieldDecorator } = this.form
      const { label, key, type, options, openKey = '开启', closeKey = '关闭', optionKey, optionValue, keyValue } = fields
      // console.log('====')
      // console.log(label, key, type, options)
      // console.log('options =====>   ', options)
      return (
        <FormItem label={label}>
          {
            getFieldDecorator(key, {})(
              type === 'input' ? (
                <Input allowClear placeholder={`请输入${label}`}></Input>
              ) : type === 'select' ? (
                <BSelect
                  keyValue={keyValue}
                  optionKey={optionKey}
                  optionValue={optionValue}
                  loadOptions={options}
                  allowClear
                  showSearch
                  optionFilterProp="title"
                  placeholder={`请选择${label}`}
                ></BSelect>
                // <Select allowClear showSearch optionFilterProp="title" placeholder={`请选择${label}`}>
                //   {
                //     options && Array.isArray(options) ? (
                //       options.map((o) => (
                //         <Option key={o.key} title={o.value}>{o.value}</Option>
                //       ))
                //     ) : null
                //   }
                // </Select>
              ) : type === 'switch' ? (
                <Switch checkedChildren={openKey} unCheckedChildren={closeKey}></Switch>
              ) : type === 'rangePicker' ? (
                <RangePicker format={['YYYY-MM-DD', 'YYYY-MM-DD']}></RangePicker>
              ) : type === 'datePicker' ? (
                <DatePicker style="width: 100%;"></DatePicker>
              ) : (
                <Input allowClear></Input>
              )
            )
          }
        </FormItem>
      )
    },
    renderCols () {
      return (
        this.searchList.map((it, id) => {
          return (
            <Col md={8} sm={24} key={id}>
              {this.renderFormItem(it)}
            </Col>
          )
        })
      )
    }
  },
  render () {
    const { right } = this.$slots
    const classes = !right ? 'search-wrap-space-between' : 'search-wrap-space-right'
    return (
      <div class="table-page-search-wrapper">
        <Form layout="inline">
          <Row gutter={48}>
            {this.renderCols()}
            <Col span={24}>
              <span class={styles[classes]}>
                <span class={styles['search-left']}>
                  {
                    Object.keys(this.$slots).map(name => {
                      return this.$slots[name]
                    })
                  }
                </span>
                {
                  !right ? (
                    <span class={styles['search-right']}>
                      <Button type="primary" onClick={this.searchHandler}>查询</Button>
                      <Button onClick={this.resetHandler}>重置</Button>
                    </span>
                  ) : null
                }
              </span>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}
//
// const BSearch = Form.create({})(Search)
export default Search
